var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6655 0H5.33455C2.38836 0 0 2.38837 0 5.33456V26.6655C0 29.6117 2.38836 32 5.33455 32H26.6655C29.6116 32 32 29.6117 32 26.6655V5.33456C32 2.38837 29.6116 0 26.6655 0Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3148 14.5906C18.4109 14.5906 20.1101 12.8914 20.1101 10.7953C20.1101 8.69921 18.4109 7 16.3148 7C14.2187 7 12.5195 8.69921 12.5195 10.7953C12.5195 12.8914 14.2187 14.5906 16.3148 14.5906Z",
    fill: "#E4E4E4",
    stroke: "#0A090A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.9991C10 21.5038 12.8352 18.6836 16.3155 18.6836C19.7958 18.6836 22.631 21.5188 22.631 24.9991",
    fill: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.9991C10 21.5038 12.8352 18.6836 16.3155 18.6836C19.7958 18.6836 22.631 21.5188 22.631 24.9991",
    stroke: "#0A090A",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileProfile);
export default __webpack_public_path__ + "static/media/profile_profile.a013de1f46725c4c10e0c9dbb17ba69f.svg";
export { ForwardRef as ReactComponent };